// extracted by mini-css-extract-plugin
module.exports = {"modalWindowOverlay":"DialogStack_modalWindowOverlay__1xD--"};